import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

import InlineConfirmation from "components/InlineConfirmation"

const ApproveInterview = ({ id }) => {
  const [, runMutation] = useMutation(workflowMutation)

  const handleSubmit = () => {
    return runMutation({ id }).then(result => {
      if (result.error) {
        NotificationManager.error(result.error.message)
      }

      const { failures } = result.data.approveInterview
      if (failures) {
        NotificationManager.error(failures.map(f => f.message).join(", "))
      } else {
        NotificationManager.success("Interview approved")
      }
    })
  }

  return (
    <InlineConfirmation
      handleSubmit={handleSubmit}
      buttonText="Approve Interview"
      type="success"
    />
  )
}

const workflowMutation = gql`
  mutation ($id: ID!) {
    approveInterview(id: $id) {
      failures {
        message
      }
      tutorApplication {
        id
      }
    }
  }
`

export default ApproveInterview
